export default "__VITE_ASSET__a72be152__"